import React, { Component } from "react";


import { isMobileApp } from "../../../actions/Util";

import Icon from "../../2/Controls/Icon";
import Spinner from "../../Common/Spinner";
import CustomTable from "../../2/Controls/CustomTable";
import { getProperty } from "../../../CommonFunctions";

class ProductInstock extends Component {
    constructor(props) {
        super(props);

        this.state = {
            stockData: [],
            loading: false,
            showTableDetail: false,
            itemLedgerData: [],
            itemLedgerDataLoading: false,
            storeName: "",
        };
    }

    componentDidMount() {
        this.fetchData(
            getProperty(this.props.productData, "key")
        );
    }

    fetchData = async (productId) => {
        this.setState({ loading: true });

        try {
            const data =
                await this.props.getInstockProductApi(productId);

            console.log("data in stock qty", data);

            this.setState({
                stockData:
                    getProperty(data, "inStock") || [],
            });
        } catch (error) {
            console.log("error",error);
            alert("Failed to load data!");
        } finally {
            this.setState({ loading: false });
        }
    };

    fetchInstockDetailData = async (
        productId,
        locationId
    ) => {
        this.setState({
            itemLedgerDataLoading: true,
        });

        try {
            const data =
                await this.props.getInstockDetailSingleProduct(
                    productId,
                    locationId
                );

         

            this.setState({
                itemLedgerData:
                    getProperty(data, "itemLedgers") || [],
            });
        } catch (error) {
            console.log("error",error);
            alert("Failed to load data!");
        } finally {
            this.setState({
                itemLedgerDataLoading: false,
            });
        }
    };

    handleOnRow = (row) => {
        this.setState({
            showTableDetail: true,
            storeName: getProperty(row, "StoreName"),
        });

        this.fetchInstockDetailData(
            getProperty(this.props.productData, "key"),
            getProperty(row, "LocationID")
        );

        console.log(
            "location id",
            getProperty(row, "LocationID")
        );

        console.log(row);
    };

    render() {
        const {
            stockData,
            loading,
            showTableDetail,
            itemLedgerData,
            itemLedgerDataLoading,
            storeName,
        } = this.state;

        // Columns for the first table
        const columns = [
            {
                field: "StoreName",
                headerName: "Store Name",
            },
            {
                field: "Location",
                headerName: "Location",
            },
            {
                field: "InStockQty",
                headerName: "Stock Qty",
            },
        ];

        // Map stock data to rows
        const rows = stockData.map((item) => ({
            StoreName: getProperty(
                item,
                "StoreName"
            ),
            InStockQty: getProperty(
                item,
                "InStockQty"
            ),
            LocationID: getProperty(
                item,
                "LocationID"
            ),
            Location: getProperty(item, "Location"),
        }));

        // Columns for detail table
        const inDetailColumn = [
            {
                field: "ActionOn",
                headerName: "Date",
                type: "date",
            },
            {
                field: "Location",
                headerName: "Location",
            },
            {
                field: "TransactionType",
                headerName: "Transaction Type",
            },
            {
                field: "TransactionNo",
                headerName: "Transaction No",
            },
            {
                field: "Action",
                headerName:
                    "Transaction Action",
            },
            {
                field: "TransactionQty",
                headerName:
                    "Transaction Qty",
                align: "right",
            },
            {
                field: "InStockQty",
                headerName: "In Stock Qty",
                align: "right",
            },
        ];

        const inDetailRow =
            itemLedgerData.map((item) => ({
                ActionOn: getProperty(
                    item,
                    "ActionOn"
                ),
                Location: getProperty(
                    item,
                    "Location"
                ),
                TransactionType: getProperty(
                    item,
                    "TransactionType"
                ),
                TransactionNo: getProperty(
                    item,
                    "TransactionNo"
                ),
                Action: getProperty(
                    item,
                    "Action"
                ),
                TransactionQty: getProperty(
                    item,
                    "TransactionQty"
                ),
                InStockQty: getProperty(
                    item,
                    "InStockQty"
                ),
            }));

        return (
            <>
                <div
                    style={{
                        flex: 1,
                        padding: "16px",
                    }}
                >
                    {loading && <Spinner hideOverlay={true}/>}

                    {!loading &&
                        rows.length > 0 && (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection:
                                        isMobileApp()
                                            ? "column"
                                            : "row",
                                    gap: "16px",
                                }}
                            >
                                {/* Left Table */}
                                <div
                                    style={{
                                        width:
                                            isMobileApp()
                                                ? "100%"
                                                : "25%",
                                    }}
                                >
                                    <CustomTable
                                        handleOnRow={
                                            this
                                                .handleOnRow
                                        }
                                        columns={
                                            columns
                                        }
                                        rows={rows}
                                    />
                                </div>

                                {/* Right Detail Table */}
                                {showTableDetail && (
                                    <div
                                        style={{
                                            width:
                                                isMobileApp()
                                                    ? "100%"
                                                    : "72%",
                                            overflow:
                                                "hidden",
                                        }}
                                    >
                                        {itemLedgerDataLoading ? (
                                            "Loading..."
                                        ) : (
                                            <>
                                                <div
                                                    style={{
                                                        marginBottom:
                                                            "8px",
                                                        display:
                                                            "flex",
                                                        alignItems:
                                                            "center",
                                                        justifyContent:
                                                            "space-between",
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            fontSize:
                                                                "16px",
                                                        }}
                                                    >
                                                        {
                                                            storeName
                                                        }
                                                    </span>

                                                    <span
                                                        style={{
                                                            width: "24px",
                                                            color: "var(--list-item-gray)",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                            this.setState(
                                                                {
                                                                    showTableDetail:
                                                                        false,
                                                                }
                                                            )
                                                        }
                                                        onMouseEnter={(
                                                            e
                                                        ) =>
                                                            (e.currentTarget.style.color =
                                                                "#111827")
                                                        }
                                                        onMouseLeave={(
                                                            e
                                                        ) =>
                                                            (e.currentTarget.style.color =
                                                                "var(--list-item-gray)")
                                                        }
                                                    >
                                                        <Icon
                                                            type={
                                                                "remove"
                                                            }
                                                        />
                                                    </span>
                                                </div>

                                                <CustomTable
                                                    columns={
                                                        inDetailColumn
                                                    }
                                                    rows={
                                                        inDetailRow
                                                    }
                                                />
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}

                    {!loading &&
                        rows.length === 0 && (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems:
                                        "center",
                                    justifyContent:
                                        "center",
                                }}
                            >
                                No Data Available!
                            </div>
                        )}
                </div>
            </>
        );
    }
}

export default ProductInstock;